<template>
    <CreateModelLayout
        :indexRoute="$route('admin::my-vacations.index')"
        :storeRoute="$route('admin::my-vacations.store')"
        :modelNameSingular="__('admin::vacations.vacation_request')"
        :modelNamePlural="__('admin::vacations.vacation_requests')"
        :form="form"
    >

        <VacationForm
            v-model="form"
            :userOptions="userOptions"
            :vacationMessageDefault="vacationMessageDefault"
        />

    </CreateModelLayout>
</template>

<script>
export default {
    props: {
        userOptions: Object,
        vacationMessageDefault: Object,
    },
    data() {
        return {
            form: this.$inertia.form({
                starts_at: null,
                ends_at: null,
                returns_at: null,
                days_to_show_notice_before_start: null,
                deputy_user_id: null,
                comment: null,
                use_default_messages: true,
                appendix_before_vacation_message: this.vacationMessageDefault?.appendix_before_vacation_message || null,
                appendix_during_vacation_message: this.vacationMessageDefault?.appendix_during_vacation_message || null,
                autoreply_subject: this.vacationMessageDefault?.autoreply_subject || null,
                autoreply_message: this.vacationMessageDefault?.autoreply_message || null,
            })
        }
    },
}
</script>
